<script>
import videoData from "@/utils/training-data/short_video_data.json";
export default {
    data() {
        return {
            dataOptions: [
                "7天","15天","30天"
            ],
            dayIndex: 0,
            coreData: videoData.trendData,
            tableData: videoData.tableData,
            tableKey: 0,
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.setHomeChart();
        });
        this.tableData = videoData.tableData.slice(0, 7)
    },
    methods: {
        setChart(ref, data) {
            const chart = this.$echarts.init(ref);

            const options = {
                grid: {
                    top: 1,
                    left: 0,
                    bottom: 1,
                    right: 0,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false, // 避免额外间隙
                    data: data.x,
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        show: false,
                    },
                },
                yAxis: {
                    type: "value",
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    axisLabel: {
                        show: false,
                    },
                },
                series: [
                    {
                        data: data.y,
                        type: "line",
                        showSymbol: false,
                        smooth: true,
                        lineStyle: {
                            color: "#3b62e7",
                        },
                    },
                ],
            };

            chart.setOption(options);
        },
        changeTags(key) {
            this.tableKey++;
            this.dayIndex = key;
            console.log("key", key)
            if (key === 0) {
                this.tableData = videoData.tableData.slice(0,7)
            }
            if (key === 1) {
                this.tableData = videoData.tableData.slice(0,15)
            }
            if (key === 2) {
                this.tableData = videoData.tableData
            }
            this.setHomeChart()
        },
        setHomeChart() {
            this.coreData.forEach((item, index) => {
                if (this.$refs[item.ref][0]) {
                    const data = this.coreData[index].data[this.dayIndex];
                    this.setChart(this.$refs[item.ref][0], data);
                }
            })
        },
    }
}
</script>

<template>
    <div class="short-video-main">
        <el-scrollbar style="height: 100%;">
            <div class="nav-tabs-wrapper" style="margin: 16px 0;">
                <div class="day-tabs" v-for="(day, key) in dataOptions" :class="dayIndex === key ? 'active' : ''" :key="key" @click="changeTags(key)">
                    {{day}}
                </div>
            </div>
            <div class="content-analysis">
                <div class="analysis-item" v-for="item in coreData" :key="item.ref">
                    <div class="item-header">
                        <span>{{ item.label }}</span>

                        <el-popover popper-class="dark-popover" placement="top" width="200" trigger="hover" :content="item.tip">
                            <i class="el-icon-question" slot="reference" v-if="!!item.tip"></i>
                        </el-popover>
                    </div>

                    <div :class="['item-value', { 'down': item.count < 0 }]">
                        {{ item.count[dayIndex] }}
                    </div>

                    <div class="item-chart" :ref="item.ref"></div>

                    <div class="item-trend">同比{{ item.trend[dayIndex] }}% <i class="el-icon-caret-top"></i></div>
                </div>
            </div>
            <div class="table-data">
                <div class="table-header">
                    <div>详细数据</div>
                    <el-button :disabled="true" size="small">下载数据</el-button>
                </div>
                <el-table :data="tableData" header-cell-class-name="custom-header">
                    <el-table-column label="日期" prop="date" />
                    <el-table-column label="主页访问量" prop="page_views" />
                    <el-table-column>
                        <template slot="header" slot-scope="scope">
                            <span>新增粉丝数</span>
                            <el-tooltip effect="dark" placement="top" content="新增粉丝数 = 昨日粉丝数 - 前日粉丝数，若出现负数可能是由于粉丝取关">
                                &nbsp;<i style="margin-left: 4px;color: #C4C4C4;" class="el-icon-question"></i>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.new_followers}}
                        </template>
                    </el-table-column>
                    <el-table-column label="粉丝数" prop="total_followers" />
                    <el-table-column label="视频播放量" prop="video_plays" />
                    <el-table-column>
                        <template slot="header" slot-scope="scope">
                            <span>获得点赞数</span>
                            <el-tooltip effect="dark" placement="top" content="新增点赞数 = 昨日点赞数 - 前日点赞数，若出现负数可能是由于取消点赞">
                                &nbsp;<i style="margin-left: 4px;color: #C4C4C4;" class="el-icon-question"></i>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.likes}}
                        </template>
                    </el-table-column>
                    <el-table-column>
                        <template slot="header" slot-scope="scope">
                            <span>获得评论数</span>
                            <el-tooltip effect="dark" placement="top" content="新增评论数 = 昨日评论数 - 前日评论数，若出现负数可能是由于取消评论">
                                &nbsp;<i style="margin-left: 4px;color: #C4C4C4;" class="el-icon-question"></i>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.comments}}
                        </template>
                    </el-table-column>
                    <el-table-column label="获得分享数" prop="shares" />
                </el-table>
            </div>
        </el-scrollbar>
    </div>

</template>

<style scoped lang="scss">
.short-video-main{
    &, & * {
        box-sizing: border-box;
    }
    &:deep(.el-scrollbar) {
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }
    }
    width: 100%;
    height: 100%;
    .table-data {
        &:deep(.el-table) {
            .custom-header {
                background: #f5f7fa;
                color: #161823;
            }
        }
        background: #fff;
        width: 100%;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        .table-header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 20px 32px;

        }
    }
    .nav-tabs-wrapper {
        width: 100%;
        height: 80px;
        background: #fff;
        border-radius: 15px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 30px;
        .day-tabs {
            cursor: pointer;
            width: 110px;
            height: 38px;
            border-radius: 5px;
            border: 1px solid #D9DADC;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #50525A;
            margin-right: 10px;
            &.active {
                color: #2B55E5;
                border-color: #2B55E5;
            }

        }

    }
    .content-analysis {
        background-color: #ffffff;
        border-radius: 12px;
        margin-bottom: 16px;
        padding: 24px 24px 16px;
        display: flex;
        gap: 16px;

        .analysis-item {
            width: 274px;
            height: 180px;
            padding: 16px;
            border: 1px solid #1618230f;
            border-radius: 4px;
            box-sizing: border-box;

            .item-header {
                display: flex;
                align-items: center;
                font-size: 14px;
                color: #666666;
                gap: 4px;

                .el-icon-question {
                    color: #999999;
                    cursor: pointer;
                }
            }

            .item-value {
                height: 32px;
                // background-color: red;
                margin-top: 12px;
                font-weight: 600;
                font-size: 30px;
                display: flex;
                align-items: center;

                &.down {
                    font-size: 14px;
                    color: #999999;
                    font-weight: 500;
                }
            }

            .item-chart {
                // background-color: blue;
                // border: 1px solid rgba(0, 0, 0, 0.1);
                margin-top: 12px;
                height: 48px;
            }

            .item-trend {
                margin-top: 12px;
                display: flex;
                align-items: center;
                gap: 4px;

                color: #999999;

                .el-icon-caret-top {
                    color: #7aca53;
                }
            }
        }
    }
}

</style>
